import { render, staticRenderFns } from "./annualuserjk.vue?vue&type=template&id=67a5953e&"
import script from "./annualuserjk.vue?vue&type=script&lang=js&"
export * from "./annualuserjk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports